import { ReactNode } from "react";
import { motion } from "framer-motion";
import SectionQr from '../components/SectionQr';
import { ChapterSection } from '../ServicesMenuChapter.interface';
import { NIKE_EASE } from '../../../../rise/constants/nikerise';
import {
    DEFAULT_CAROUSEL_ITEM_DURATION_S,
    DEFAULT_TRANSITION_DURATION
} from '../ServiceMenuChapter.constants';

interface VariantWrapperProps {
    children: ReactNode,
    section: ChapterSection,
}

function VariantWrapper(props: VariantWrapperProps) {
    const { children, section } = props;

    return (
        <motion.div
            style={{
                position: 'relative',
                width: '100vw',
                height: '100vh'
            }}
            transition={{
                duration: DEFAULT_TRANSITION_DURATION,
                ease: NIKE_EASE,
            }}
            exit={{
                y: `-100vh`,
                transition: {
                    ease: NIKE_EASE,
                    duration: DEFAULT_TRANSITION_DURATION,
                },
            }}
        >
            {children}

            {section?.has_qr_code ? (
                <SectionQr
                    media={section?.qr_code?.media}
                    title={section?.qr_code?.title}
                    subtitle={section?.qr_code?.subtitle}
                    delay={DEFAULT_CAROUSEL_ITEM_DURATION_S}
                />
            ) : null}
        </motion.div>
    )
}

export default VariantWrapper;
